import { gql } from "@apollo/client"

export const SUBSCRIPTION_SHOP_CUTPOINT = gql`
subscription Subscription($onShopCutPointShopId: ID!) {
  onShopCutPoint(shopId: $onShopCutPointShopId) {
    id
    point
  }
}
`;